<div id="actionButtonsContainer" class="flexRowContainer">
  <button mat-icon-button (click)="backToCasesOverview()"
          aria-label="Back to cases overview">
    <mat-icon class="material-symbols-outlined">arrow_back</mat-icon>
  </button>
  <div class="flexRowContainer">
    @if (builderFormUrl) {
      <button mat-flat-button (click)="completeDataCapturing()">
        <span>{{ 'caseCreation.buttons.buildCase.label' | translate }}</span>
      </button>
    }
  </div>
</div>
@if (!builderFormUrl) {
  <div id="caseCreationContainer" class="flexColumnContainer">
    <p class="headline-small">{{ 'caseCreation.title' | translate }}</p>
    <div id="customerSelectionContainer" class="flexRowContainer">
      <mat-icon class="material-symbols-outlined stepIcon">person</mat-icon>
      <div class="flexColumnContainer">
        <p class="title-medium">{{ 'caseCreation.customerSelection.title' | translate }}</p>
        <p class="body-medium">{{ 'caseCreation.customerSelection.description' | translate }}</p>
        <app-user-selection (userSelected)="customerSelected($event)"
                            (userDeselected)="customerUnselected()"></app-user-selection>
      </div>
    </div>
    <div id="caseInformationContainer">
      <div class="flexRowContainer">
        <mat-icon class="material-symbols-outlined stepIcon">folder_info</mat-icon>
        <div class="flexColumnContainer">
          <p class="title-medium">{{ 'caseCreation.caseInformation.title' | translate }}</p>
          <p class="body-medium">{{ 'caseCreation.caseInformation.description.title' | translate }}</p>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'caseCreation.caseInformation.name.label' | translate }}</mat-label>
            <input matInput [formControl]="caseNameFormControl"
                   placeholder="{{ 'caseCreation.caseInformation.name.placeholder' | translate}}">
            @if (caseNameFormControl.hasError('required')) {
              <mat-error>
                {{ 'caseCreation.caseInformation.name.requiredErrorMessage' | translate }}
              </mat-error>
            }
            @if (caseNameFormControl.hasError('maxlength')) {
              <mat-error>
                {{ 'caseCreation.caseInformation.name.maxLengthErrorMessage' | translate }}
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'caseCreation.caseInformation.description.label' | translate }}</mat-label>
            <input matInput [formControl]="caseDescriptionFormControl"
                   placeholder="{{ 'caseCreation.caseInformation.description.placeholder' | translate}}">
            @if (caseDescriptionFormControl.hasError('maxlength')) {
              <mat-error>
                {{ 'caseCreation.caseInformation.description.maxLengthErrorMessage' | translate }}
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field id="referenceFormField" appearance="outline">
            <mat-label>{{ 'caseCreation.caseInformation.reference.label' | translate }}</mat-label>
            <input matInput [formControl]="caseReferenceFormControl"
                   placeholder="{{ 'caseCreation.caseInformation.reference.placeholder' | translate}}">
            @if (caseReferenceFormControl.hasError('maxlength')) {
              <mat-error>
                {{ 'caseCreation.caseInformation.reference.maxLengthErrorMessage' | translate }}
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    </div>
    <div id="caseContentsContainer">
      <div class="flexRowContainer">
        <mat-icon class="material-symbols-outlined stepIcon">view_list</mat-icon>
        <div class="flexColumnContainer">
          <p class="title-medium">{{ 'caseCreation.caseContents.title' | translate }}</p>
          <p class="body-medium">{{ 'caseCreation.caseContents.description' | translate }}</p>
          <mat-radio-group [(ngModel)]="caseContent">
            <mat-radio-button value="empty">{{ 'caseCreation.caseContents.radioButtons.emptyCase' | translate }}
            </mat-radio-button>
            <mat-radio-button value="template">{{ 'caseCreation.caseContents.radioButtons.template' | translate }}
            </mat-radio-button>
          </mat-radio-group>
          @if (caseContent === 'template') {
            <mat-form-field appearance="outline">
              <mat-label class="body-large">{{ 'caseCreation.caseContents.template.label' | translate }}</mat-label>
              <input type="text" class="body-large"
                     aria-label="Search for template"
                     matInput
                     [formControl]="caseTemplateFormControl"
                     [matAutocomplete]="auto">
              <mat-icon class="material-symbols-outlined" matPrefix>document_search</mat-icon>
              @if (loadingSearchResult && !chosenBuilderForm) {
                <mat-spinner id="searchFormsSpinner" diameter="30"
                             matSuffix></mat-spinner>
              }
              @if (chosenBuilderForm) {
                <button id="clearFormSearchButton" mat-icon-button matSuffix
                  (click)="removeChosenTemplate()"
                  aria-label="Clear template selection">
                  <mat-icon class="material-symbols-outlined">clear</mat-icon>
                </button>
              }
              <mat-autocomplete class="body-large" autoActiveFirstOption #auto="matAutocomplete"
                                (optionSelected)="templateSelected($event.option.value)">
                @for (template of filteredTemplates | async; track template) {
                  <mat-option [value]="template">
                    <div id="formBuilderTemplate" class="flexColumnContainer">
                      <span class="body-large">{{ template.title }}</span>
                    </div>
                  </mat-option>
                }
                @if ((filteredTemplates | async)?.length === 0) {
                  <mat-option disabled>
                    <div class="flexColumnContainer">
                      <span
                        class="body-large">{{ 'caseCreation.caseContents.template.emptyOption.label' | translate }}</span>
                    </div>
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          }
        </div>
      </div>
    </div>
    <div id="actionsContainer" class="flexRowContainer">
      <button
        mat-flat-button
        [disabled]="!customer || !caseNameFormControl.valid || (caseContent === 'template' && !chosenBuilderForm)"
        (click)="createCase()"
      >
        {{ 'caseCreation.buttons.createCase.label' | translate }}
      </button>
    </div>
  </div>
}
@if (builderFormUrl) {
  <div id="iframeContainer">
    <iframe id="formBuilder" (load)="iframeLoaded()" frameBorder="0" [src]="builderFormUrl | safe"></iframe>
  </div>
}
